/**
 * Component: Header navigation
 *
 * Dependencies:
 * - OwlCarousel 2.x.x
 */

var prongHorn = prongHorn || {};

prongHorn.variantPicker = prongHorn.variantPicker || function() {
    var self = this;
    var $form = $('#product');
    var $container = $('.variant-picker');
    var $trigger = $('.variant-picker__trigger')
    var $master = $container.next('.variant-master').first();
    var formInvalid = true; 

    this.init = function() {

        $trigger.on('change', function(){
            $master.val(getValues());
        })

        self.validateUpgrade();

    };

    this.validateUpgrade = function() {
        var $cartBtn = $('.product__addtocart');

        $cartBtn.click(function(event) {
            event.preventDefault();
            if($trigger.length) {
                    getValues();

                    if(!formInvalid){
                        prongHorn.product.ajaxSubmit($form);
                    } else {
                        prongHorn.product.ajaxMsg($form, false); // Apply error msg class
                    }

            } else {
                prongHorn.product.ajaxSubmit($form);
            }
        });
    }

    function getValues() {
        var arr = [];
        var string = "";
        var hasError = false;

        // Loop over the containers
        $container.each(function(){
            var $this = $(this);
            var $trigger = $this.children('.variant-picker__trigger');
            var $title = $this.children('.variant-picker__title');
            var val = "";

            // If its a radio button find the checked input
            // Else if its a select, just find the value of the select
            // Push values to empty array;
            if($this.hasClass('variant-picker--radio')) {
                val = $this.children('.variant-picker__trigger:checked').val();

            } else if ($this.hasClass('variant-picker--select')) {
                val = $this.children('.variant-picker__trigger').val()
            }

            console.log(val);
            // Validate the inputs
            if(val && typeof val !== 'undefined') {
                $trigger.removeClass('variant-picker__trigger--error');
                $title.removeClass('variant-picker__title--error');
                
                if(!hasError)
                    formInvalid = false;              
            } else {
                formInvalid = true;
                hasError = true;
                $trigger.addClass('variant-picker__trigger--error');
                $title.addClass('variant-picker__title--error');
            }

            arr.push(val);

        })

        // Join the arr with a dot and return the string
        string = arr.join('.');

        return string;
    }

    // Public functions
    return {
        init: init
    };

}();